import React, { useState } from 'react';

import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import {
    Divider,
    IconButton,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Stack,
    Switch,
    Tooltip,
    Typography
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { usePageHeaderContext } from './pageHeaderContext';
import SettaLogo from './settaLogo';
import { useThemeMode } from '../theme/themeModeContext';
import { removeToken } from '../utils/loginTokens';
import { getPageHeaderByPath } from '../utils/menuSections';

const AppTopBar = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const { isDarkMode, toggleThemeMode } = useThemeMode();
    const { pageHeader } = usePageHeaderContext();
    const location = useLocation();
    const open = Boolean(anchorEl);
    const routeHeader = getPageHeaderByPath(location.pathname);
    const activeHeader = pageHeader?.pathname === location.pathname ? pageHeader : routeHeader;
    const HeaderIcon = activeHeader.icon || routeHeader.icon;

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        handleClose();
        await removeToken();
    };

    return (
        <header className='app-topbar'>
            <div className='app-topbar-panel'>
                <Link to='/' className='app-topbar-brand' aria-label='Ir para a página inicial'>
                    <SettaLogo height={26} onNavy />
                </Link>

                <div className='app-topbar-title-group'>
                    {HeaderIcon && (
                        <div className='app-topbar-title-icon'>
                            <HeaderIcon fontSize='small' />
                        </div>
                    )}
                    <div className='app-topbar-copy'>
                        <Typography component='p' className='app-topbar-eyebrow'>
                            {activeHeader.eyebrow || routeHeader.eyebrow || 'Setta'}
                        </Typography>
                        <Typography component='h1' className='app-topbar-title'>
                            {activeHeader.title || routeHeader.title}
                        </Typography>
                    </div>
                </div>

                <div className='app-topbar-actions'>
                    <Tooltip title='Configurações'>
                        <IconButton
                            aria-controls={open ? 'app-settings-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            aria-haspopup='true'
                            aria-label='Abrir configurações'
                            className='app-settings-button'
                            onClick={handleOpen}
                        >
                            <SettingsRoundedIcon fontSize='small' />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>

            <Menu
                id='app-settings-menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{ className: 'app-settings-menu-paper' }}
            >
                <Stack className='app-settings-menu-heading'>
                    <Typography variant='overline'>Configurações</Typography>
                    <Typography variant='h6'>Preferências</Typography>
                </Stack>

                <MenuItem className='app-settings-theme-item' onClick={toggleThemeMode}>
                    <ListItemIcon>
                        {isDarkMode ? <DarkModeRoundedIcon fontSize='small' /> : <LightModeRoundedIcon fontSize='small' />}
                    </ListItemIcon>
                    <ListItemText
                        primary={isDarkMode ? 'Tema Escuro' : 'Tema Claro'}
                        primaryTypographyProps={{ fontWeight: 600 }}
                    />
                    <Switch
                        checked={isDarkMode}
                        inputProps={{ 'aria-label': 'Alternar tema escuro' }}
                        onChange={toggleThemeMode}
                        onClick={(event) => event.stopPropagation()}
                    />
                </MenuItem>

                <Divider className='app-settings-divider' />

                <MenuItem className='app-settings-logout-item' onClick={handleLogout}>
                    <ListItemIcon>
                        <LogoutRoundedIcon fontSize='small' />
                    </ListItemIcon>
                    <ListItemText primary='Logout' primaryTypographyProps={{ fontWeight: 600 }} />
                </MenuItem>
            </Menu>
        </header>
    );
};

export default AppTopBar;
